import { http } from './http';
import type {
  User,
  UserSetting,
  UpdateUserProfileRequest,
  UpdateUserSettingRequest,
  GetMembershipResponse,
  MembershipPlan,
} from '@daynote/shared-types';

export const userApi = {
  getMe: () => http.get<unknown, User>('/user/me'),
  updateMe: (data: UpdateUserProfileRequest) =>
    http.patch<unknown, User>('/user/me', data),
  getSetting: () => http.get<unknown, UserSetting>('/user/setting'),
  updateSetting: (data: UpdateUserSettingRequest) =>
    http.patch<unknown, UserSetting>('/user/setting', data),
  getMembership: () => http.get<unknown, GetMembershipResponse>('/user/membership'),
  getMembershipPlans: () => http.get<unknown, MembershipPlan[]>('/membership/plans'),
  uploadBackground: (file: File) => {
    const form = new FormData();
    form.append('file', file);
    return http.post<unknown, { url: string }>('/user/background', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
